import React, { useState } from "react";

import { Form } from "react-bootstrap";

import classNames from "classnames";
import { Controller, RegisterOptions, useFormContext } from "react-hook-form";

import styles from "./Select.module.scss";

interface SelectProps {
  label: string;
  name: string;
  rules?: RegisterOptions;
  placeholder?: string;
  screenSpan?: "half-screen" | "full-screen";
  selectOptions: string[];
}

const Select = ({
  label,
  name,
  rules,
  placeholder,
  selectOptions,
  screenSpan = "half-screen",
  ...rest
}: SelectProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const [colour, setColour] = useState("monoGrey3");

  return (
    <Form.Group className={screenSpan === "half-screen" ? styles["span-one-col-in-grid"] : ""}>
      <Form.Label>{label}</Form.Label>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState }) => (
          <Form.Select
            {...field}
            onChange={(e) => {
              field.onChange(e);
              setColour("monoBlack");
            }}
            {...rest}
            isInvalid={fieldState.error !== undefined}
            className={classNames(styles["form-select"], styles[colour])}
          >
            <option hidden value="">
              {placeholder}
            </option>
            {selectOptions.map((option) => (
              <option key={option} value={option} className={styles["select-options"]}>
                {option}
              </option>
            ))}
          </Form.Select>
        )}
      />
      {errors?.[name]?.message && (
        <Form.Control.Feedback type="invalid">{errors?.[name]?.message.toString()}</Form.Control.Feedback>
      )}
    </Form.Group>
  );
};

export default Select;
